<template>
  <b-badge
    :pill="pill"
    :variant="badgeVariant"
    :class="[badgeClass, 'app-badge']"
    v-b-tooltip.hover.auto.v-warning="badgeTitle"
  >
    <span
      v-if="featherIcon"
      :class="featherIconClass"
    >
      <app-feather
        :icon="featherIcon"
        :size="featherIconSize"
        :customize-size="featherIconCustomizeSize"
      />
    </span>
    <span
      v-if="badgeText"
      :class="[badgeTextClass, 'app-badge__text']"
    >{{ badgeText }}</span>
  </b-badge>
</template>

<script>

import { BBadge, VBTooltip } from 'bootstrap-vue'
import AppFeather from '@/views/components/app-feather/AppFeather.vue'
import useApp from '@/composables/app'

export default {
  name: 'AppBadge',
  components: { AppFeather, BBadge },
  props: {
    badgeClass: [String, Object],
    badgeVariant: {
      type: [String, null],
      required: false,
      default: () => 'light-primary',
    },
    badgeTitle: String,
    badgeText: String,
    featherIcon: {
      type: String,
      required: false,
      validator: val => useApp().featherIconTypes.includes(val),
    },
    featherIconSize: {
      type: [String, null],
      required: false,
      default: () => '18',
    },
    featherIconClass: {
      type: String,
      required: false,
      default: () => 'mr-25',
    },
    featherIconCustomizeSize: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    badgeTextClass: {
      type: String,
      required: false,
    },
    pill: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  directives: {
    'b-tooltip': VBTooltip
  },
}
</script>

<style lang='scss'>

.app-badge {
  &__text {
    white-space: normal;
    line-height: 1.2;
  }
}

</style>